import { Button } from "@/components/ui/button";
import { SmartCatalogTheme as ThemePayload } from "@/services/walter-assistant";
import { useState } from "react";
import { SmartCatalogTheme } from "./smart-catalog-theme";
import { DISPLAY_INITIAL_N_THEMES_PER_GROUP, DISPLAY_NEXT_N_THEMES_PER_GROUP } from "./smart-catalog.utils";

type Props = {
    themes: ThemePayload[];
    /** Appelé avec les thèmes nouvellement révélés à chaque clic sur "Voir plus". */
    onRevealThemes?: (newThemes: ThemePayload[]) => void;
};

/** Thèmes d'un sous-catalogue (santé / généraliste) avec expansion lot-par-lot. */
export function SmartCatalogSubTableGroupContent({ themes, onRevealThemes }: Props) {
    const [visibleCount, setVisibleCount] = useState(DISPLAY_INITIAL_N_THEMES_PER_GROUP);
    const visibleThemes = themes.slice(0, visibleCount);
    const remainingCount = themes.length - visibleCount;
    const hasMore = remainingCount > 0;

    function handleShowMore() {
        const nextCount = Math.min(visibleCount + DISPLAY_NEXT_N_THEMES_PER_GROUP, themes.length);
        const newlyRevealed = themes.slice(visibleCount, nextCount);
        setVisibleCount(nextCount);
        if (newlyRevealed.length > 0) {
            onRevealThemes?.(newlyRevealed);
        }
    }

    return (
        <div className="flex flex-col gap-3">
            {visibleThemes.map(theme => (
                <SmartCatalogTheme key={theme.theme_code} theme={theme} />
            ))}
            {hasMore ? (
                <Button
                    type="button"
                    variant="link"
                    size="sm"
                    className="h-7 w-full text-xs text-blue-600 hover:text-blue-900"
                    onClick={handleShowMore}
                >
                    {`Voir plus de thèmes (${remainingCount})`}
                </Button>
            ) : null}
        </div>
    );
}
